import loadable from '@loadable/component';
import React from 'react';
import { ProductDetailsFragment, SizeInventoryFragment } from '../../../../generated/types';
import { LazyLoad } from '../../../LazyLoad';

import './ProductDetailsFavoriteSectionMobile.scss';

interface Props {
  variant: ProductDetailsFragment;
  size: SizeInventoryFragment | null;
}

const FavoriteButton = loadable(() => import('../../../../components/Favorite'), {
  resolveComponent: exports => exports.FavoriteButton
});

export const ProductDetailsFavoriteSectionMobile: React.FC<Props> = ({ variant }) => {
  return (
    <LazyLoad>
      <FavoriteButton
        className="ProductDetailsFavoriteSectionMobile__fav-button"
        variant={variant}
      />
    </LazyLoad>
  );
};
